import FolderIcon from '@mui/icons-material/Folder';
import PieChartIcon from '@mui/icons-material/PieChart';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import QueryStatsIcon from '@mui/icons-material/QueryStats';

export const mainSidebarItems =[
    {
        id: 0,
        icon: <FolderIcon />,
        label: 'Portfolio',
        route: '/portfolio'
    },
    {
        id: 1,
        icon: <PieChartIcon />,
        label: 'Activity Reports',
        route: '/activity-reports'
    },
    /* {
        id: 2,
        icon: <BubbleChartIcon />,
        label: 'Research',
        route: '/research'
    },
    {
        id: 3,
        icon: <QueryStatsIcon />,
        label: 'Risk Analysis',
        route: '/risk-analysis'
    } */
]